import type { FC, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

import { Card } from "mds/components/Card";

interface PublishingCardProps {
  children: ReactNode;
  className?: string;
}

export const PublishingCard: FC<PublishingCardProps> = ({ children, className }) => (
  <Card
    className={twMerge(
      "rounded-[12px] bg-white px-6 py-4 !shadow-none supports-squircle:rounded-[24px] supports-squircle:corner-squircle",
      className,
    )}
  >
    {children}
  </Card>
);
